module.exports = __webpack_public_path__ + "img/di17.4f211eed.png";